/**
 * @module getAuthenticationWindowProperties
 */

/**
 * @function
 * To get property list string for authentication window
 * @returns A string  of properties
 */

const getAuthenticationWindowProperties = (): string => {
    const width = 640;
    const height = 520;
    const props = {
        width: width,
        height: height,
        left: (window.screen.width - width) / 2,
        top: (window.screen.height - height) / 2,
        modal: 'yes',
        alwaysRaised: 'yes',
        menubar: 'no',
        status: 'no',
        scrollbars: 'no',
        titlebar: 'no',
        toolbar: 'no',
        resizable: 'yes',
    };

    const propString = Object.keys(props)
        .map(key => key + '=' + props[key])
        .join(',');

    return propString;
};

export default getAuthenticationWindowProperties;
